<div class="row h-100 m-0">
  <div class="col-xl-6 col-lg-12">
    <div id="race-entry" class="card shadow-sm rounded race-entry race-entry-page race-constructor pb-0">
      <div class="card-title bg-blue">
        <h4 class="m-0">Drivers In Race</h4>
      </div>
      <div class="card-body p-0" *ngIf="preLoader!=true">
        <div class="row race-entry-details h-100 m-0">
          <div class="col-lg-12 p-2">
            <div class="row m-0 h-100">

              <div class="col-lg-12" id="myDIV">
                <h5 class="mb-3" *ngIf="circuitDetail!=undefined">{{circuitDetail.name}}
                  {{circuitDetail.location!=null?','+circuitDetail.location:''}}{{circuitDetail.country!=null?','+circuitDetail.country:''}}
                </h5>
                <ul class="list-unstyled race-entry-list flex-wrap">

                  <li *ngFor="let driverobj of raceDrivers; let i=index">
                    <!-- if edit btn not available -->
                    <div class="race-entry-ranking" *ngIf="showEditButton==false">
                      <div class="ranking">

                        <span class="picture">
                          <img *ngIf="driverobj.driverPic!=null||driverobj.driverPic!=undefined ; else defaultImg"
                            src={{driverobj.driverPic}} alt="driver" />
                        </span>
                        <span class="name">{{driverobj.foreName+" "+driverobj.surName}}</span>

                      </div>
                    </div>

                    <!-- if  edit btn available -->
                    <div class="race-entry-ranking" *ngIf="showEditButton==true">
                      <div class="ranking" (click)="addDriver(i);addscss()">
                        <span class="picture">
                          <i *ngIf="driverobj.driverId!=0" class="fa fa-times pull-right cross" aria-hidden="true"
                            (click)="removeFromDriverList(driverobj)"></i>
                          <img *ngIf="driverobj.driverId!=0" src={{driverobj.driverPic}} alt="driver" />
                          <i *ngIf="driverobj.driverId==0" class="fa fa-plus"></i>
                        </span>
                        <span class="name">{{driverobj.foreName!=undefined?driverobj.foreName:''}}
                          {{driverobj.surName!=undefined?driverobj.surName:''}}</span>

                      </div>
                    </div>
                  </li>
                </ul>

                <div class="text-center">
                  <button type="submit" class="btn btn-outline-primary mt-4 mb-2 mx-1 mx-sm-2" data-dismiss="modal"
                    [routerLink]="'/admin/raceResult'">Cancel </button>
                  <button type="submit" *ngIf="showEditButton==true" [disabled]="enableSaveButton()"
                    class="btn btn-primary mt-4 mb-2 mx-1 mx-sm-2" (click)="saveDrivers()">save</button>
                </div>

              </div>
            </div>

          </div>
        </div>


      </div>
      <div class="box-loader" *ngIf="preLoader">
        <img src="assets/img/progress.svg" alt="Progress">
      </div>
    </div>
  </div>
  <!-- //For master Drivers -->
  <div class="col-xl-6 col-lg-12">
    <div id="race-entry" class="card shadow-sm rounded race-entry race-entry-page race-constructor pb-0">
      <div class="card-title bg-blue">
        <h4 class="m-0">Drivers</h4>
      </div>
      <div class="card-body p-0">
        <div class="row race-entry-details h-100 m-0">
          <div class="col-lg-12 p-2">
            <div class="row m-0 h-100">

              <div class="col-lg-12" id="myDIV">

                <ul class="list-unstyled race-entry-list flex-wrap">

                  <li *ngFor="let driverobj of masterDrivers; let i=index">
                    <!-- if edit btn not available -->
                    <div class="race-entry-ranking" *ngIf="showEditButton==false">
                      <div class="ranking">

                        <span class="picture">
                          <img src={{driverobj.driverPic}} alt="driver" />
                        </span>
                        <span class="name">{{driverobj.foreName+" "+driverobj.surName}}</span>

                      </div>
                    </div>

                    <!-- if  edit btn available -->
                    <div class="race-entry-ranking" *ngIf="showEditButton==true">
                      <div class="ranking">

                        <span class="picture">
                          <img src={{driverobj.driverPic}} alt="driver" (click)="addMaster(driverobj)" />
                        </span>
                        <span class="name">{{driverobj.foreName+" "+driverobj.surName}}</span>

                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>

          </div>
        </div>


      </div>
      <div class="box-loader" *ngIf="preLoader">
        <img src="assets/img/progress.svg" alt="Progress">
      </div>
    </div>
  </div>

  <ng-template defaultImg>
    <img src="../../../assets/img/1.jpg" alt="driver" />
  </ng-template>
</div>